import * as React from 'react';
import { SVGProps } from 'react';

const IconHelmetSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1 7a4.502 4.502 0 0 1 3.103-4.279c-.004-.144.01-.298.051-.454a1.39 1.39 0 0 1 .933-.975C5.62 1.12 6.495 1 8 1s2.38.12 2.913.292c.49.158.814.531.933.975.041.156.055.31.05.454A4.502 4.502 0 0 1 15 7v3.5a2.5 2.5 0 0 1-1.5 4.5h-11A2.5 2.5 0 0 1 1 10.5V7Zm5.25-3.913 1.199 3.597a1 1 0 1 1-1.898.632l-.89-2.672A2.501 2.501 0 0 0 3 7v3h10V7a2.502 2.502 0 0 0-1.66-2.356l-.891 2.672a1 1 0 0 1-1.898-.632l1.2-3.597C9.38 3.04 8.823 3 8 3c-.824 0-1.38.04-1.75.087ZM2.5 12h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1 0-1Z"
    />
  </svg>
);
export default IconHelmetSizeS;
